export function useGetCompletedShipmentsChartData(data) {

    const config = {

        type: 'doughnut',
        data: {
            labels: data.map(each => each.label),
            datasets: [{
                label: 'Completed Shipments',
                data: data.map(each => each.value),
                borderWidth: 1,
                backgroundColor: [
                    '#11557a',
                    'rgb(50,131,89, 0.5)',
                    'rgb(248,213,0, 0.5)',
                    'rgb(122,29,152, 0.5)'
                ],
                cutout: '50%',
                borderRadius: 6
            }],

        },
        options: {
            plugins: {
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        boxWidth: 12,
                    }
                },

            },
            responsive: true,
            hoverOffset: 15,
            scales: {},
            layout: {
                padding: 20,
                font: {
                    family: 'roboto'
                }
            }
        }

    }

    return config;

}
